import { ErrorModal } from '../../Modal';
import * as api from '../../../../services/api';
import { useEffect, useState } from 'react';
import { FaFileExcel } from 'react-icons/fa';
import { toast } from 'react-toastify';
import DownloadXLSX from '../../../../utils/DownloadXLSX/DownloadXLSX';
import { DefaultMessage } from '../../../../utils/defaultMessages';
import { IoDocumentText } from 'react-icons/io5';

export default function Execution() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [downloadValid, setDownloadValid] = useState<boolean>(true);
  const [errorMessage] = useState<string>('');
  const [, setRefreshCount] = useState(0);
  const [dataUpdate, setDataUpdate] = useState([]);
  const setModal = (stateModal: boolean) => {
    setIsOpen(stateModal);
  };

  const [checkboxes, setCheckboxes] = useState<any>({
    crawler_tractor: false,
    tractor: false,
    small_loader: false,
    mini_excavator: false,
    loader: false,
    backhoe: false,
    harvester: false,
    body_on_chassis: false,
    truck: false,
    planter: false,
    seeder: false,
    sprayer: false,
    roller_compactor: false,
    crane: false,
    mechanical_horse: false,
  });

  const rows = [
    { name: 'truck', label: 'CAMINHÃO' },
    { name: 'body_on_chassis', label: 'CARROCERIA SOBRE CHASSI' },
    { name: 'harvester', label: 'COLHEITADEIRA' },
    { name: 'mechanical_horse', label: 'CAVALO MECÂNICO' },
    { name: 'crane', label: 'GUINDASTE' },
    { name: 'small_loader', label: 'MINI CARREGADEIRA' },
    { name: 'mini_excavator', label: 'MINI ESCAVADEIRA' },
    { name: 'loader', label: 'PÁ CARREGADEIRA' },
    { name: 'planter', label: 'PLANTADEIRA' },
    { name: 'sprayer', label: 'PULVERIZADOR' },
    { name: 'backhoe', label: 'RETROESCAVADEIRA' },
    { name: 'roller_compactor', label: 'ROLO CAMPACTADOR' },
    { name: 'semitrailer', label: 'SEMIRREBOQUE' },
    { name: 'seeder', label: 'SEMEADORA' },
    { name: 'tractor', label: 'TRATOR' },
    { name: 'crawler_tractor', label: 'TRATOR ESTEIRA' },
  ];

  const ProcessedIn = (name: string) => {
    const found: any = dataUpdate.find((item: any) => item.product === name);

    if (found) {
      return new Date(found.updated_at).toLocaleString();
    }
    return '-';
  };

  const Action = (name: string) => {
    const found: any = dataUpdate.find((item: any) => item.product === name);
    if (found && downloadValid === false) {
      return (
        <button disabled>
          <FaFileExcel size={23} color={'#d3d3d3'} />
        </button>
      );
    }

    if (found && found.status === 'SUCCESS') {
      return (
        <button data-testid='button-action-sucess' onClick={() => downloadXLSX(name)}>
          <FaFileExcel size={23} color={'#059705'} />
        </button>
      );
    }
    if (found && found.status === 'FAILURE') {
      return (
        <div className="flex flex-row items-start justify-start gap-2">
          <button data-testid='button-action-failure' onClick={() => downloadXLSX(name)}>
            <FaFileExcel size={23} color={'#059705'} />
          </button>
          <button data-testid='button-action-failure-message' onClick={() => downloadXLSX(name, found.error_detail)}>
            <IoDocumentText size={25} color={'#FFA500'} />
          </button>
        </div>
      );
    }
    return '-';
  };

  const Status = (name: string) => {
    const found: any = dataUpdate.find((item: any) => item.product === name);

    if (found) {
      if (found.status === 'PENDING') {
        return (
          <div className="flex items-center">
            <div className="w-4 h-4 bg-yellow-300 rounded-full mr-2"></div>
            PENDENTE
          </div>
        );
      }
      if (found.status === 'SUCCESS') {
        return (
          <div className="flex items-center">
            <div className="w-4 h-4 bg-green-400 rounded-full mr-2"></div>
            SUCESSO
          </div>
        );
      }
      if (found.status === 'FAILURE') {
        return (
          <div className="flex items-center">
            <div className="w-4 h-4 bg-red-500 rounded-full mr-2"></div>FALHOU
          </div>
        );
      }
    }
    return '-';
  };

  const downloadXLSX = async (machine: string, message: string = '') => {
    if (message) {
      toast.error(`Motivo da falha: ${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    await api
      .get(`/table/crawler/generate/excel/${machine}/`)
      .then((response: any) => {
        if (response.status === 200) {
          toast.warn('Aguarde, esta sendo gerado o excel!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 35000,
          });
          setDownloadValid(false);
          checkStatus(response.data.task_id);
        }
        if (response.status === 400) {
          toast.error(response.data.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        if (response.status === 500) {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const checkStatus = async (taskId: string) => {
    let elapsedTime = 0;
    const intervalTime = 30000;
    const maxTime = 300000;

    const interval = setInterval(async () => {
      try {
        const response: any = await api.get(
          `/table/crawler/check_status/?task_id=${taskId}`,
        );

        if (
          response.status === 200 &&
          response.data.content.result.status === 'XLSX_GENERATED'
        ) {
          clearInterval(interval);
          setDownloadValid(true);
          DownloadXLSX(`/table/crawler/download/excel/${taskId}/`);
          toast.success('Arquivo pronto para download!', {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
        // if (response.status === 200 && response.data.content.status === "FAILURE") {
        //     clearInterval(interval);
        //     setDownloadValid(true)
        //     toast.error("A operação falhou", {
        //         position: toast.POSITION.TOP_RIGHT
        //     });
        //     return
        // }
      } catch (error) {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setDownloadValid(true);
        return;
      }

      elapsedTime += intervalTime;

      if (elapsedTime >= maxTime) {
        clearInterval(interval);
        toast.error('Tempo limite atingido! O arquivo não foi gerado.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setDownloadValid(true);
        return;
      }
    }, intervalTime);
  };

  async function handleSubmit(event: any) {
    event.preventDefault();
    Object.keys(checkboxes).forEach((item: string) => {
      if (checkboxes[item]) {
        Execute(item);
      }
    });
  }

  async function Execute(machine: string) {
    let machineParam = machine.trim();
    let machineParamObj = { machine: machine.trim() };

    localStorage.removeItem(`Processed_${machineParam}`);

    const resp: any = await api.post(
      `/table/crawler/automation/all/sites/?machine=${machineParam}`,
      machineParamObj,
    );

    if (resp.status === 202) {
      localStorage.setItem(machine, resp.data.content.task_id);
      localStorage.setItem('task_id', resp.data.content.task_id);
      setRefreshCount((prev) => prev + 1);
    }
    return;
  }

  const handleCheckboxChange = (event: any) => {
    setCheckboxes({
      ...checkboxes,
      [event.target.name]: event.target.checked,
    });
  };

  const refreshProduct = async (Isclick: boolean) => {
    try {
      const response: any = await api.get('/crawler/manage_crawler/list/');
      if (response.status === 200) {
        setDataUpdate(response.data.content.results);
        if (Isclick) {
          toast.success('Atualizado com sucesso!', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    } catch (error) {
      toast.error(DefaultMessage.ERROR, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    refreshProduct(false);
  }, []);

  // const isAnyCheckboxSelected = Object.values(checkboxes).some(Boolean);
  const isAnyCheckboxSelected = false;
  const disabledTrue = true;

  return (
    <div className="bg-white rounded-b-xl">
      <ErrorModal
        setModal={setModal}
        state={isOpen}
        errorMessage={errorMessage}
      />
      <div className="h-full w-full overflow-x-auto flex justify-center md:justify-start md:ml-[3rem] py-9 text-gray-700 text-[14px] sm:text-[.9rem]">
        <div className="h-[max-content] divTable w-[70vw] md:w-[82vw] bg-white rounded-xl overflow-x-auto">
          <form onSubmit={handleSubmit}>
            <table className="w-full rounded-xl overflow-hidden shadow-sm min-w-[800px]">
              <thead>
                <tr className="bg-[#00AEEF] h-20 sm:h-14 font-semibold text-white text-md">
                  <th className="w-[32%] px-4">BUSCADORES</th>
                  <th className="w-[32%]">STATUS</th>
                  <th className="w-[32%]">PROCESSADO EM</th>
                  <th className="w-[4%] px-4">AÇÃO</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  // const isDisabled = robotLocalStorage[row.id];
                  const isDisabled = true;
                  return (
                    <tr
                      key={row.name}
                      className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                      style={{ height: '50px' }}
                    >
                      <td className="w-[32%] px-4">
                        <label
                          htmlFor={row.name}
                          className={`${disabledTrue ? '' : 'hover:cursor-pointer'}`}
                        >
                          <input
                            type="checkbox"
                            id={row.name}
                            className={`${disabledTrue ? '' : 'hover:cursor-pointer'} rounded-sm h-5 w-5 border-2 mr-4`}
                            onChange={handleCheckboxChange}
                            checked={checkboxes[row.name]}
                            name={row.name}
                            style={isDisabled ? { background: 'gray' } : {}}
                            disabled={isDisabled}
                          />
                          {row.label}
                        </label>
                      </td>
                      <td className="w-[32%]">{Status(row.name)}</td>
                      <td className="w-[32%]">{ProcessedIn(row.name)}</td>
                      <td className="w-[4%] px-4">{Action(row.name)}</td>
                    </tr>
                  );
                })}
                <tr className="bg-white h-20 sm:h-14">
                  <td className="w-[32%] px-4"></td>
                  <td className="w-[32%] px-4"></td>
                  <td className="w-[32%] px-4">
                    <button
                      className="font-semibold text-white bg-[#00AEEF] px-4 py-2 rounded-md text-[14px] sm:text-[1rem]"
                      onClick={() => refreshProduct(true)}
                    >
                      ATUALIZAR
                    </button>
                  </td>
                  <td className="w-[4%] px-4">
                    <button
                      className="font-semibold text-white bg-[#6fbf8c] px-4 py-2 rounded-md text-[14px] sm:text-[1rem]"
                      style={
                        !isAnyCheckboxSelected
                          ? { background: 'lightgray' }
                          : {}
                      }
                      disabled={!isAnyCheckboxSelected}
                    >
                      EXECUTAR
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  );
}
